import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import CityMod from '@components/Caja';
import Boton from '@components/Boton';
import Resumen from '@components/Resumen';
import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { MEMBERSHIP_URL } from '@utils/const';

function Modalidad() {
  const location = useLocation();
  const navigate = useNavigate();
  const [modalidadSeleccionada, setModalidadSeleccionada] = useState(null);

  const ciudadId = location.state?.ciudadId;
  const ciudadNombre = location.state?.ciudadNombre;
  const servicioId = location.state?.servicioId;
  const sedeId = location.state?.sedeId;

  const modalidad = [
    { "id": "1", "modalidad": "Presencial" },
    { "id": "2", "modalidad": "Telesalud" },
    { "id": "3", "modalidad": "Domiciliaria" },
  ];

  const continuarAFechas = () => {
    if (!modalidadSeleccionada) {
      alert('Por favor selecciona una modalidad');
      return;
    }
    navigate('/fechas', {
      state: {
        ciudadId: ciudadId,
        ciudadNombre: ciudadNombre,
        servicioId: servicioId,
        sedeId: sedeId,
        modalidadId: modalidadSeleccionada
      }
    });
  };

  useEffect(() => {
    console.log('Ciudad ID:', ciudadId);
    console.log('Servicio ID:', servicioId);
    console.log('Sede ID:', sedeId);
  }, [ciudadId, servicioId, sedeId]);

  // Validación: si no hay sesión en localStorage o es "0", redirigir a membresía
  useEffect(() => {
    const idUsu = localStorage.getItem('idUsu');
    if (!idUsu || idUsu === '0') {
      window.location.href = MEMBERSHIP_URL;
      return;
    }
  }, []);

  return (
    <div id="cajaPrincipal" 
      style={cajaPrincipalStyle}
    >
     <Titulo titulo="Modalidad" subtitulo=""></Titulo>

        <div id="cajaCentral" style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          marginLeft: '20vh',
          gap: '4vh',
          marginTop: '3vh',
          justifyContent: 'center',
          alignItems: 'center'
        }}>

          {/* Imagen de modalidad */}
          <div id="cajaImageModalidad" style={{
            width: '48.5vh',
            height: '37.1vh',
            transform: 'rotate(0deg)',
            opacity: 1,
            marginRight: 'auto',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <img
              src="/moda.png"
              alt="Modalidad"
              style={{
                width: '90%',
                height: '90%',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>

        {/* Contenedor de modalidades */}
        <div id="cajModalidad" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1vh',
          marginTop: '0vh',
          marginLeft: '17vh',
          width: '70vh'
        }}>
          {/* Texto de instrucción */}
          <h3 style={{
            fontFamily: 'Inter',
            fontSize: '2.5vh',
            fontWeight: 'bold',
            color: '#333',
            marginLeft: '17vh',
          }}>
            Seleccione la modalidad
          </h3>

          {/* Contenedor de modalidades */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1vh',
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
          }}>
            {/* Mapeo de modalidades */}
            {modalidad.map((item, index) => (
              <CityMod
                key={index}
                label={item.modalidad}
                onClick={() => setModalidadSeleccionada(item.id)}
                isSelected={modalidadSeleccionada === item.id}
              />
            ))}
          </div>
        </div>

        {/* Botón Continuar */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: '63vh',
          marginTop: '3vh',
          marginLeft: '35vh',
          gap: '2vh'
        }}>
          <Boton
            label="Continuar"
            onClick={continuarAFechas}
            ancho="23vh"
            alto="5.2vh"
            disabled={!modalidadSeleccionada}
          />
        </div>
      {/* Contenedor derecho para el resumen */}


    </div>
  );
}

export default Modalidad;